import { Injectable } from '@angular/core';
import { BaseService, httpOptions } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DynamicFormService extends  BaseService{

  constructor(http:HttpClient) {
    super(http);
  }

  getUrl(): string {
    return "api/dynamic-form";
  }

  /** POST: 发布 */
  deploy(id):Observable<any> {
    return this.http.post<any>('api/dynamic-form/'+id+'/deploy', httpOptions).pipe(
      tap((object:any) => this.log(`deploy object =${object}`)),
      catchError(this.handleError<any>('deploy any'))
    );
  }


  /**
   * 通过代码查找
   * @param code
   */
  getByCode(code:String):Observable<any> {
    const url = `${this.getUrl()}/code/${code}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object code=${code}`)),
      catchError(this.handleError<any>(`get any code=${code}`))
    );
  }


  /**
   * 通过类型查找所有
   * @param type
   */
  getAllByType(type: String): Observable<any> {
    const url = `${this.getUrl()}/all/${type}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`get all object type=${type}`)),
      catchError(this.handleError<any>(`get all object type=${type}`)),
    );
  }

}
